/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

const ButtonBase = props => {
  const buttonProps = {
    className: classnames(
      styles.buttonBase,
      { [styles.disabled]: props.disabled },
      { [styles.fullWidth]: props.fullWidth },
      ...props.styles
    ),
    onClick: !props.disabled ? props.onClick : null,
    disabled: props.disabled,
    href: !props.disabled ? props.href : null,
    to: !props.disabled ? props.to : null
  };
  if (props.to)
    return (
      <Link {...buttonProps}>
        <span>{props.children}</span>
      </Link>
    );
  if (props.href && props.noTarget) {
    return (
      <a {...buttonProps}>
        <span>{props.children}</span>
      </a>
    );
  }
  if (props.href)
    return (
      <a {...buttonProps} target={props.target || '_blank'} rel="noopener noreferrer">
        <span>{props.children}</span>
      </a>
    );
  return (
    <button type={props.type} {...buttonProps}>
      <span>{props.children}</span>
    </button>
  );
};

ButtonBase.propTypes = {
  children: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  href: PropTypes.string,
  target: PropTypes.string,
  noTarget: PropTypes.bool,
  to: PropTypes.string,
  type: PropTypes.string,
  styles: PropTypes.array
};

ButtonBase.defaultProps = {
  children: null,
  onClick: null,
  disabled: false,
  fullWidth: false,
  href: null,
  target: null,
  noTarget: false,
  to: null,
  type: 'button',
  styles: []
};

export default ButtonBase;
